<template>
  <div class="deposit-terms">
    <!-- ===== چک‌باکس با لینک آبی ===== -->
    <div class="terms-checkbox">
      <label class="checkbox-label">
        <input
            type="checkbox"
            :checked="value"
            @change="$emit('input', $event.target.checked)"
        />
        <span class="checkbox-text">
          {{ terms.checkboxText }}
          <a
              href="#"
              class="terms-link"
              @click.prevent="showModal = true"
          >
            {{ terms.linkText }}
          </a>
        </span>
      </label>
    </div>

    <!-- ===== پاپ‌آپ قوانین ===== -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>📜 {{ terms.title }}</h3>
          <button class="btn-close" @click="showModal = false">✕</button>
        </div>
        <div class="modal-body">
          <pre>{{ terms.content }}</pre>
        </div>
        <div class="modal-footer">
          <small>نسخه {{ terms.version }} — آخرین به‌روزرسانی: {{ terms.lastUpdated }}</small>
          <div class="modal-actions">
            <button class="btn-accept" @click="acceptTerms">
              ✅ متوجه شدم و می‌پذیرم
            </button>
            <button class="btn-close-footer" @click="showModal = false">
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DEPOSIT_TERMS from '@/constants/depositTerms';

export default {
  name: 'DepositTerms',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    // نوع: 'marketOwner' برای سالن‌دار، 'customer' برای مشتری
    type: {
      type: String,
      default: 'customer',
      validator: function(val) {
        return ['marketOwner', 'customer'].indexOf(val) !== -1;
      }
    }
  },

  data: function() {
    return {
      showModal: false
    };
  },

  computed: {
    terms: function() {
      return DEPOSIT_TERMS[this.type] || DEPOSIT_TERMS.customer;
    }
  },

  methods: {
    // ===== تایید از داخل پاپ‌آپ =====
    acceptTerms: function() {
      this.$emit('input', true);
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
/* ========================================== */
/* استایل‌های اصلی */
/* ========================================== */
.deposit-terms {
  direction: rtl;
}

/* ========================================== */
/* چک‌باکس */
/* ========================================== */
.terms-checkbox {
  padding: 14px 16px;
  background: #f8f9fa;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  cursor: pointer;
  flex-shrink: 0;
}

.checkbox-text {
  font-size: 13px;
  color: #303133;
  line-height: 1.8;
}

/* ========================================== */
/* لینک آبی قوانین */
/* ========================================== */
.terms-link {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px dashed #409eff;
  margin-right: 4px;
  transition: all 0.2s;
}

.terms-link:hover {
  color: #66b1ff;
  border-bottom-color: #66b1ff;
}

/* ========================================== */
/* پاپ‌آپ */
/* ========================================== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 700px;
  width: 92%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s;
}

@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* ===== هدر ===== */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 16px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #909399;
  padding: 0;
  line-height: 1;
}

.btn-close:hover {
  color: #2c3e50;
}

/* ===== بدنه ===== */
.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.modal-body pre {
  margin: 0;
  font-family: inherit;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 2;
  font-size: 13px;
  color: #303133;
}

/* ===== فوتر ===== */
.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.modal-footer small {
  display: block;
  font-size: 11px;
  color: #909399;
  margin-bottom: 12px;
  text-align: center;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn-accept {
  padding: 10px 24px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-accept:hover {
  background: #66b1ff;
}

.btn-close-footer {
  padding: 10px 24px;
  background: #f5f7fa;
  color: #606266;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.btn-close-footer:hover {
  background: #e4e7ed;
}

/* ========================================== */
/* ریسپانسیو */
/* ========================================== */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-height: 90vh;
  }

  .modal-header h3 {
    font-size: 14px;
  }

  .modal-body {
    padding: 14px;
  }

  .modal-body pre {
    font-size: 12px;
    line-height: 1.8;
  }

  .modal-actions {
    flex-direction: column;
  }

  .modal-actions .btn-accept,
  .modal-actions .btn-close-footer {
    width: 100%;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .checkbox-text {
    font-size: 12px;
  }

  .modal-header {
    padding: 12px 16px;
  }

  .modal-footer {
    padding: 12px 16px;
  }
}
</style>